import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { getPasswordRequirementStates } from '../../utils/password-validation'
import * as styles from '../../styles/components/password-requirements.module.scss'

const PasswordRequirements = ({ password, fieldId }) => {
  const requirements = useMemo(() => getPasswordRequirementStates(password), [password])

  return (
    <div
      className={styles.root}
      id={`${fieldId}-requirements`}
      role="region"
      aria-live="polite"
      aria-label="Password requirements"
    >
      <p className={styles.title}>Your password must include:</p>
      <ul className={styles.list}>
        {requirements.map((req) => (
          <li
            key={req.id}
            className={`${styles.item} ${req.met ? styles.itemMet : styles.itemPending}`}
          >
            <span className={styles.indicator} aria-hidden="true" />
            <span>{req.label}</span>
            <span className={styles.srOnly}>{req.met ? 'requirement met' : 'requirement not met'}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

PasswordRequirements.propTypes = {
  password: PropTypes.string,
  fieldId: PropTypes.string.isRequired
}

export default PasswordRequirements
